module.exports = __webpack_public_path__ + "static/img/arrow-right.be07dae1.svg";